


































import { Vue, Component, Watch } from 'vue-property-decorator'
import { mapGetters } from 'vuex'
import SkosTree from './SkosTree'
import ClassTree from './ClassTree'
import OntologiesLeftPane from './OntologiesLeftPane'
import sparqlService from '../service/SparqlService'
import main from '../main'

@Component({
  components: { SkosTree, ClassTree, OntologiesLeftPane },
  computed: mapGetters([
    'skosRoot',
    'classRoot',
    'leftPane',
    'ontology',
    'browserName'
  ])
})
export default class Sidebar extends Vue {
  activeTab:any = null

  @Watch('ontology')
  watchOntology () {
    var onto = main.store.getters.ontology

    if (onto && onto.id != '') {
      if (onto.skos) {
        main.store.commit('leftPane', 'SkosTree')
        sparqlService.getSkosTreeAsync()
      } else {
        main.store.commit('leftPane', 'ClassTree')
        sparqlService.getClassTreeAsync()
      }
    }
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Sidebar.vue